import fetchApi from './api';
import fetchApiBlob from './apiBlob';
import {ApiResponse, SearchPaging} from 'models/model';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const TeacherCreate = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Teacher/Create', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export const TeacherUpdate = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Teacher/Update', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const TeacherGetPaging = async (data: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Teacher/GetPaging', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const TeacherGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Teacher/Get', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const TeacherDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Teacher/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
}

export const TeacherImport = async (file: File): Promise<ApiResponse> => {
    const formData = new FormData();
    formData.append("formFile", file);
    return fetchApi<any>('/Teacher/Import', {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json',

        }
    });
};


export const TeacherDownloadTemplate = async (): Promise<Blob> => {
    return fetchApiBlob<any>('/Teacher/Template', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });
};



